
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphDialog extends Serenity.EntityDialog<GraphRow, any> {
        protected getFormKey() { return GraphForm.formKey; }
        protected getIdProperty() { return GraphRow.idProperty; }
        protected getLocalTextPrefix() { return GraphRow.localTextPrefix; }
        protected getNameProperty() { return GraphRow.nameProperty; }
        protected getService() { return GraphService.baseUrl; }

        protected form = new GraphForm(this.idPrefix);

    }
}